export function formatPrintValue(value) {
  if (value == null || value === "") return "";
  if (typeof value === "object" && typeof value.format === "function") {
    return value.format("hh:mm A");
  }
  if (typeof value === "object" && value.name) return value.name;
  return String(value);
}

export function formatPrintDate(value) {
  if (!value) return "";
  const date = new Date(value);
  if (!Number.isNaN(date.getTime())) {
    return date.toLocaleDateString("en-GB");
  }
  return String(value);
}

export function formatPrintTime(value) {
  if (!value) return "";
  if (typeof value.format === "function") return value.format("hh:mm A");
  return String(value);
}

export function formatDisplayTime(value) {
  if (!value) return "";
  const text = String(value).trim();
  const match = text.match(/^(\d{1,2}:\d{2})(:\d{2})?$/);
  if (match) return match[1];
  return text;
}

export const ARABIC_MONTHS = [
  "يناير",
  "فبراير",
  "مارس",
  "أبريل",
  "مايو",
  "يونيو",
  "يوليو",
  "أغسطس",
  "سبتمبر",
  "أكتوبر",
  "نوفمبر",
  "ديسمبر",
];

export function formatArabicMonth(monthNumber) {
  const num = parseInt(monthNumber, 10);
  if (num >= 1 && num <= 12) return ARABIC_MONTHS[num - 1];
  return formatPrintValue(monthNumber);
}

export function filterByEmployeeName(data, searchTerm) {
  if (!Array.isArray(data)) return [];
  const term = String(searchTerm || "").trim().toLowerCase();
  if (!term) return data;
  return data.filter((item) =>
    String(item.employeeName || "").toLowerCase().includes(term),
  );
}

export function filterSalariesBySearch(data, searchTerm) {
  return filterByEmployeeName(data, searchTerm);
}

export function getSalaryMultiplier(jopType, jopTypeNumber) {
  if (jopType === "بالشهر") return 1;
  const count = parseFloat(jopTypeNumber) || 0;
  return count > 0 ? count : 1;
}

export function getJopTypeNumberLabel(jopType) {
  if (jopType === "بالساعة") return "عدد الساعات";
  if (jopType === "باليوم") return "عدد الأيام";
  if (jopType === "بالأسبوع") return "عدد الأسابيع";
  if (jopType === "بالشهر") return "الشهر";
  if (jopType === "حسب الأتفاق") return "حسب الأتفاق";
  return "عدد";
}

export function getAttendanceStatusLabel(status) {
  if (status === "Presence") return "حضور";
  if (status === "Departure") return "انصراف";
  return formatPrintValue(status);
}

export function getRoleLabel(role) {
  if (role === 6 || role === "6") return "صلاحيات كاملة";
  if (role === 5 || role === "5") return "حضور وانصراف";
  return formatPrintValue(role);
}

export const ADMIN_REQUEST_LABELS = {
  RegularLeave: "اجازة اعتيادية",
  EmergencyLeave: "اجازة عارضة",
  AnnualLeave: "اجازة سنوية",
  SickLeave: "اجازة مرضي",
  PermissionToLeave: "اذن انصراف",
  PermissionForDelay: "اذن تأخير",
  OfficialTaskPermit: "اذن مأمورية",
  ComplaintRequest: "طلب شكوى",
  InquiryRequest: "طلب استفسار",
  BorrowRequest: "طلب سلفة",
};

export function getAdminRequestLabel(request) {
  return ADMIN_REQUEST_LABELS[request] || formatPrintValue(request);
}

export function formatApprovalPrintValue(approvedById, approvedByName) {
  if (approvedById && approvedById !== 0) {
    return approvedByName
      ? `تمت الموافقة بواسطة ${approvedByName}`
      : "تمت الموافقة";
  }
  return "تحت المراجعة";
}

export function buildAdminRequestPrintFields({
  EmployeesId,
  Datee,
  Request,
  DateFrom,
  DateTo,
  TimeFrom,
  TimeTo,
  NumberOfDays,
  NumberOfHours,
  BorrowValue,
  NoteFile,
  Note,
  approvedById,
  approvedByName,
}) {
  const fields = [
    { label: "اسم الموظف", value: formatPrintValue(EmployeesId) },
    { label: "التاريخ", value: formatPrintDate(Datee) },
    { label: "نوع الطلب", value: getAdminRequestLabel(Request) },
  ];

  const leaveTypes = [
    "RegularLeave",
    "EmergencyLeave",
    "AnnualLeave",
    "SickLeave",
  ];
  const permissionTypes = [
    "PermissionToLeave",
    "PermissionForDelay",
    "OfficialTaskPermit",
  ];

  if (leaveTypes.includes(Request)) {
    fields.push(
      { label: "التاريخ من", value: formatPrintDate(DateFrom) },
      { label: "التاريخ إلى", value: formatPrintDate(DateTo) },
      { label: "عدد الأيام", value: formatPrintValue(NumberOfDays) }
    );
  }

  if (permissionTypes.includes(Request)) {
    fields.push(
      { label: "التوقيت من", value: formatPrintTime(TimeFrom) },
      { label: "التوقيت إلى", value: formatPrintTime(TimeTo) },
      { label: "عدد الساعات", value: formatPrintValue(NumberOfHours) }
    );
  }

  if (Request === "ComplaintRequest" || Request === "InquiryRequest") {
    fields.push({
      label: Request === "ComplaintRequest" ? "عنوان الشكوى" : "عنوان الاستفسار",
      value: formatPrintValue(NoteFile),
    });
  }

  if (Request === "BorrowRequest") {
    fields.push({ label: "قيمة السلفة", value: formatPrintValue(BorrowValue) });
  }

  fields.push(
    { label: "ملاحظات", value: formatPrintValue(Note) },
    {
      label: "حالة الموافقة",
      value: formatApprovalPrintValue(approvedById, approvedByName),
    }
  );

  return fields;
}
